var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2391931(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86196 9.57031H7.25598C7.18471 9.57031 7.12695 9.62822 7.12695 9.69963V14.8703C7.12695 14.9418 7.18471 14.9996 7.25598 14.9996H8.86196C8.93324 14.9996 8.99099 14.9418 8.99099 14.8703V9.69963C8.99099 9.62822 8.93324 9.57031 8.86196 9.57031Z",
    fill: "#2E7D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05975 7C7.4754 7 7 7.47593 7 8.06092C7 8.64617 7.4754 9.12228 8.05975 9.12228C8.64363 9.12228 9.11864 8.64614 9.11864 8.06092C9.11866 7.47593 8.64363 7 8.05975 7Z",
    fill: "#2E7D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9469 9.44336C12.3018 9.44336 11.825 9.72126 11.5358 10.037V9.70119C11.5358 9.62978 11.4781 9.57187 11.4068 9.57187H9.86878C9.7975 9.57187 9.73975 9.62978 9.73975 9.70119V14.8719C9.73975 14.9433 9.7975 15.0012 9.86878 15.0012H11.4712C11.5425 15.0012 11.6003 14.9433 11.6003 14.8719V12.3136C11.6003 11.4515 11.8339 11.1156 12.4335 11.1156C13.0866 11.1156 13.1385 11.6541 13.1385 12.3579V14.8719C13.1385 14.9433 13.1962 15.0012 13.2675 15.0012H14.8706C14.9419 15.0012 14.9996 14.9433 14.9996 14.8719V12.0357C14.9996 10.7538 14.7557 9.44336 12.9469 9.44336Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2391931);
export default __webpack_public_path__ + "static/media/Group 239193 1.753d1ff77ea71f5a2ece511f5984d88f.svg";
export { ForwardRef as ReactComponent };